module.exports = __webpack_public_path__ + "static/media/UserImageLogo_bg.35e5b006.jpg";